"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = UploadToCloud;

var _UploadToCloud = require("@adobe/react-spectrum-workflow/dist/UploadToCloud");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function UploadToCloud(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_UploadToCloud.A4uUploadToCloud, null));
}